import {
  loadFonts
} from "./ABeeZee-ay08gs2s.mjs";

// src/Bangers.ts
var getInfo = () => ({
  fontFamily: "Bangers",
  importName: "Bangers",
  version: "v25",
  url: "https://fonts.googleapis.com/css2?family=Bangers:ital,wght@0,400",
  unicodeRanges: {
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C4, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      "400": {
        vietnamese: "https://fonts.gstatic.com/s/bangers/v25/FeVQS0BTqb0h60ACH5FQ2Ixi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/bangers/v25/FeVQS0BTqb0h60ACH5BQ2Ixi.woff2",
        latin: "https://fonts.gstatic.com/s/bangers/v25/FeVQS0BTqb0h60ACH55Q2A.woff2"
      }
    }
  },
  subsets: ["latin", "latin-ext", "vietnamese"]
});
var fontFamily = "Bangers";
var loadFont = (style, options) => {
  return loadFonts(getInfo(), style, options);
};
export {
  fontFamily,
  getInfo,
  loadFont
};
